<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>{{$t('account.dati_registrazione')}}</h1></div>
            <div class="content content-full">
                <form>
                    <div class="title">{{$t('prenotazione_tavolo.dati')}}</div>
                    <div class="container">
                        <div class="row row-sezione">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" :placeholder="$t('nome')+' *'"
                                           v-model="form.nome">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" :placeholder="$t('cognome')+' *'"
                                           v-model="form.cognome">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" :placeholder="$t('telefono')+' *'"
                                           v-model="form.telefono">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" :placeholder="$t('email')+' *'"
                                           v-model="form.email">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title">{{$t('account.dati_account')}}</div>
                    <div class="container">
                        <div class="row row-sezione">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" disabled
                                           :value="this.form.email">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="password" class="form-control" autocomplete
                                           :placeholder="$t('password').capitalize()+' *'"
                                           v-model="form.password">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title">{{$t('account.indirizzo_fatturazione')}}</div>
                    <div class="container">
                        <div class="d-flex align-items-center justify-content-between mr-5 ml-5 mt-2 pl-5 pr-5"
                             v-if="this.locale.f_fat_obbligatoria">
                            <mcw-radio
                                id="billing-type-azienda"
                                v-model="form.billing_type"
                                :label="this.$t('azienda')"
                                name="billing_type"
                                value="AZIENDA"
                            />
                            <mcw-radio
                                id="billing-type-privato"
                                v-model="form.billing_type"
                                :label="this.$t('privato')"
                                name="billing_type"
                                value="PRIVATO"
                            />
                        </div>
                        <div class="row row-sezione">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.ragione_sociale"
                                                   type="text" class="form-control"
                                                   :placeholder="$t('account.reg_soc')"/>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.p_iva"
                                                   type="text" class="form-control"
                                                   :placeholder="$t('piva')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.cod_fisc" type="text"
                                                   class="form-control"
                                                   :placeholder="$t('cod_fisc')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.indirizzo"
                                                   type="text" class="form-control" :placeholder="$t('account.via')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.numero"
                                                   type="text" class="form-control"
                                                   :placeholder="$t('account.civico')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.localita_citta"
                                                   type="text" class="form-control" :placeholder="$t('account.citta')">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.cap_citta"
                                                   type="text" class="form-control" :placeholder="$t('account.cap')">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.provincia"
                                                   :maxlength="this.province_length"
                                                   type="text" class="form-control" :placeholder="$t('account.prv')">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <select v-model="form.indirizzi.fatturazione.nazione" class="form-control"
                                                    :class="{'is-invalid': !this.valid_country}"
                                                    @change="truncateProvince">
                                                <option value="">{{$t('account.sel_country')}}</option>
                                                <option v-for="country in this.countries"
                                                        :value="country.iso">
                                                    {{country.traduzione_ll.nome}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.sdi"
                                                   type="text" class="form-control" placeholder="SDI">
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.pec"
                                                   type="text" class="form-control" placeholder="PEC">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-for="checkbox in this.checkboxes">
                                <mcw-checkbox v-model="form[checkbox.db_name]">
                                    {{checkbox.label}}
                                    <a v-if="checkbox.url" href="#" class="a3" @click.prevent="openModal(checkbox)">
                                        <i>{{$t('news.leggi')}} »</i>
                                    </a>
                                </mcw-checkbox>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="container">
                        <div class="row-sezione d-flex justify-content-between">
                            <router-link :to="{name:'user'}">
                                <button type="button" class="btn btn-default">{{$t('btn_annulla')}}</button>
                            </router-link>
                            <button type="button" class="btn btn-primary" @click="submit()"
                                    :disabled="this.loading_visible">
                                {{$t('btn_salva')}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <modal v-if="this.show_modal_privacy" @close="show_modal_privacy = false" :show-title="false">
            <div slot="body">
                <iframe :src="this.privacy_link" class="w-100" style="height:500px;" frameBorder="0">
                    Browser not compatible
                </iframe>
            </div>
        </modal>
        <modal v-if="this.show_modal" @close="show_modal = false" :show-title="true" :size="'medium'">
            <div slot="header">
                <h5 class="modal-title">ACCOUNT</h5>
            </div>
            <div slot="body">
                {{$t('account.save_ok')}}
            </div>
        </modal>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {getSummary, updateCustomer} from "../../api/account";
import {getPrivacyCheckboxes} from "../../api/restaurant";

import Modal from "../partials/Modal";
import ModalErrors from "../partials/ModalErrors";
import {checkEmptyObject} from "../../libraries/utils";
import {getCountries} from "../../api/mixed";

export default {
    name: "UserEdit",
    components: {ModalErrors, Modal},
    data() {
        return {
            form: {
                email: '',
                nome: '',
                cognome: '',
                telefono: '',
                password: '',
                indirizzi: {
                    fatturazione: {
                        ragione_sociale: '',
                        p_iva: '',
                        cod_fisc: '',
                        indirizzo: '',
                        numero: '',
                        localita_citta: '',
                        cap_citta: '',
                        provincia: '',
                        nazione: '',
                        sdi: '',
                        pec: ''
                    }
                },
                billing_type: 'AZIENDA'
            },
            checkboxes: [],
            privacy_link: null,
            show_modal_privacy: false,
            show_modal: false,
            countries: []
        }
    },
    created() {
        if (this.locale.f_fat_obbligatoria) {
            this.form.billing_type = 'PRIVATO';
        }

        this.fetch();
    },
    computed: {
        province_length: function () {
            if (this.form.indirizzi.fatturazione.nazione === 'IT') {
                return 2;
            }

            return null;
        },
        valid_country: function () {
            const {nazione} = this.form.indirizzi.fatturazione;

            return nazione !== undefined;
        },
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            axios.all([
                getSummary(this.language, {
                    id_ristorante: this.id_ristorante,
                    email: this.user.email,
                    api_key: this.user.api_key
                }),
                getPrivacyCheckboxes(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                }),
                getCountries(this.language, {})
            ]).then(axios.spread((...responses) => {
                const responseSummary = responses[0];
                const responseCheckboxes = responses[1];
                const responseCountries = responses[2];

                this.form.nome = responseSummary.cliente.nome;
                this.form.cognome = responseSummary.cliente.cognome;
                this.form.email = responseSummary.cliente.email;
                this.form.telefono = responseSummary.cliente.telefono;

                this.checkboxes = responseCheckboxes.checkboxes;

                this.checkboxes.forEach((checkbox) => {
                    try {
                        this.form[checkbox.db_name] = !!responseSummary.cliente[checkbox.db_name];
                    } catch (e) {
                        this.form[checkbox.db_name] = false;
                    }
                });

                const billingAddress = responseSummary.cliente.indirizzi.find((address) => {
                    return address.tipo === 'FATTURAZIONE';
                });

                if (billingAddress) {
                    this.form.billing_type = this.locale.f_fat_obbligatoria ? billingAddress.fatturazione_tipo : 'AZIENDA';
                    this.form.indirizzi.fatturazione.cod_fisc = billingAddress.cod_fisc;
                    this.form.indirizzi.fatturazione.indirizzo = billingAddress.indirizzo;
                    this.form.indirizzi.fatturazione.numero = billingAddress.numero;
                    this.form.indirizzi.fatturazione.localita_citta = billingAddress.localita_citta;
                    this.form.indirizzi.fatturazione.cap_citta = billingAddress.cap_citta;
                    this.form.indirizzi.fatturazione.provincia = billingAddress.provincia;
                    this.form.indirizzi.fatturazione.nazione = billingAddress.nazione;


                    if (billingAddress.fatturazione_tipo === 'AZIENDA') {
                        this.form.indirizzi.fatturazione.ragione_sociale = billingAddress.ragione_sociale;
                        this.form.indirizzi.fatturazione.p_iva = billingAddress.p_iva;
                        this.form.indirizzi.fatturazione.sdi = billingAddress.sdi;
                        this.form.indirizzi.fatturazione.pec = billingAddress.pec;
                    }
                }

                this.countries = responseCountries.countries;

            })).catch(({messages}) => {
                this.showModalErrors({
                    title: 'ACCOUNT',
                    errors: messages
                });
            }).finally(() => {
                this.showLoading(false);
            })
        },
        openModal: function (checkbox) {
            this.privacy_link = checkbox.url;
            this.show_modal_privacy = true;
        },
        submit: function () {
            this.showLoading(true);

            let billingAddress = {...this.form.indirizzi.fatturazione};

            if (this.locale.f_fat_obbligatoria) {
                billingAddress.fatturazione_tipo = this.form.billing_type;
            } else if (checkEmptyObject(billingAddress)) {
                billingAddress = null;
            }

            let params = Object.assign({}, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                api_key: this.user.api_key,
                old_email: this.user.email,
                username: this.form.email
            }, this.form, {
                indirizzi: {
                    fatturazione: billingAddress
                }
            });

            delete params.billing_address;

            //accrocchio in quanto ws vuole o 1 o 0
            this.checkboxes.forEach((checkbox) => {
                if (params.hasOwnProperty(checkbox.db_name)) {
                    params[checkbox.db_name] = params[checkbox.db_name] ? 1 : 0
                }
            });

            updateCustomer(this.language, params).then(() => {
                if (this.form.email !== this.user.email) {
                    this.setUserEmail(this.form.email);
                }
                this.show_modal = true;
            }).catch(({messages}) => {
                this.showModalErrors({
                    title: 'ACCOUNT',
                    errors: messages
                });
            }).finally(() => {
                this.showLoading(false);
            })
        },
        truncateProvince: function () {
            if (this.province_length) {
                this.form.indirizzi.fatturazione.provincia = this.form.indirizzi.fatturazione.provincia.substr(0, this.province_length);
            }
        },
        ...mapActions('global', [
            'showLoading',
            'showModalErrors'
        ]),
        ...mapActions('auth', {
            setUserEmail: 'setEmail'
        })
    }
}
</script>
